import { MeshH, DoubleTintMeshMaterial, BitmapTextH } from '@/utils/pixi-heaven-compat'
import * as PIXI from 'pixi.js'

interface BitmapTextClass {
    addChild(...children: any[]): any
}

interface MeshClass {
    _renderToBatch(renderer: PIXI.Renderer): void
}

export class HeavenConvertUtil {
    public static applyBitmapTextMixin(prototype: BitmapTextClass): void {
        const originAddChild = PIXI.BitmapText.prototype.addChild

        prototype.addChild = function(this: BitmapTextH, ...children: any[]): any {
            const [child] = children

            if (child.color == null && child.geometry) {
                child.color = this.color
                child.material = new DoubleTintMeshMaterial(child.material.texture, { color: this.color })
            }

            return originAddChild.apply(this, children)
        }
    }

    public static applyMeshMixin(prototype: MeshClass): void {
        const originRender = prototype._renderToBatch

        prototype._renderToBatch = function(this: MeshH, renderer: PIXI.Renderer): void {
            this.color.alpha = this.worldAlpha
            originRender.call(this, renderer)
        }
    }
}
